import React, { useEffect } from "react";
import { useState } from "react";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import FormHelperText from "@mui/material/FormHelperText";
import { useSnackbar } from "notistack";
import {
  AddWorkoutTypeApi,
  EditWorkoutTypeApi,
} from "src/DAL/workoutType/workoutType";

export default function AddOrUpdateGeneralType({
  type,
  data,
  formType,
  reloadList,
  setOpen,
}) {
  const { enqueueSnackbar } = useSnackbar();
  const [isLoadingForm, setIsLoadingForm] = useState(false);

  const [inputs, setInputs] = useState({
    title: "",
    description: "",
    status: true,
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    let postData = {
      title: inputs.title,
      description: inputs.description,
      status: inputs.status,
    };
    if (formType === "Add") {
      postData.practice_type = type;
    }
    setIsLoadingForm(true);
    const result =
      formType === "Edit"
        ? await EditWorkoutTypeApi(postData, data?._id)
        : await AddWorkoutTypeApi(postData);
    if (result.code === 200) {
      reloadList("");
      setOpen(false);
      enqueueSnackbar(result.message, { variant: "success" });
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsLoadingForm(false);
    }
  };

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  useEffect(() => {
    if (data && formType === "Edit") {
      setInputs((prevInputs) => ({
        ...prevInputs,
        ...data,
      }));
    } else {
      setInputs({
        title: "",
        description: "",
        status: true,
      });
    }
  }, [data, formType]);

  return (
    <div className="container-fluid">
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-12 col-md-6 mt-4">
            <TextField
              id="outlined-basic"
              label="Title"
              variant="outlined"
              fullWidth
              required
              name="title"
              value={inputs.title}
              onChange={handleChange}
            />
          </div>
          <div className="col-12 col-md-6 mt-4">
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Status *</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                name="status"
                value={inputs.status}
                label="Status*"
                onChange={handleChange}
              >
                <MenuItem value={true}>Active</MenuItem>
                <MenuItem value={false}>Inactive</MenuItem>
              </Select>
            </FormControl>
          </div>
          <div className="col-12 mt-4">
            <FormControl fullWidth>
              <TextField
                id="outlined-multiline-flexible"
                label="Short Description"
                multiline
                rows={6}
                name="description"
                value={inputs.description}
                onChange={handleChange}
              />
              <FormHelperText>
                Short Description (Maximum limit 250 characters)
              </FormHelperText>
            </FormControl>
          </div>
          <div className="text-end mt-4">
            <button type="submit" className="small-contained-button">
              {isLoadingForm
                ? "Loading..."
                : formType === "Edit"
                ? "Update"
                : "Submit"}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
